// extracted by mini-css-extract-plugin
export default {"divider":"qvBC1IOgIC_pdp","horizontal":"KURJa3Mk0n_pdp","line":"pQK9WW0ge4_pdp","dashed":"cj5pOsIMtf_pdp","vertical":"s2Dc0F7xSZ_pdp"};